"use strict";import{IconVisibilityOff as i}from"../src/elements/IconVisibilityOff.js";import{defineElement as f}from"@spectrum-web-components/base/src/define-element.js";f("sp-icon-visibility-off",i);
//# sourceMappingURL=sp-icon-visibility-off.js.map
